import { Identifiable, Account } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function fillAccount(httpClient: HttpClient) {
  return (
    token: string,
    data: { lastName: string; firstName: string; password: string },
  ) =>
    httpClient
      .sendHttpRequest<Identifiable<Account>>({
        endpoint: `/resources/accept-invitation/user-not-existing?token=${token}`,
        method: HttpMethods.POST,
        data,
      })
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            alreadyConfirmed: "error.resourceHasAlreadyAcceptedInvitation",
          }),
        ),
      );
}

export { fillAccount };
